import { render, staticRenderFns } from "./demo_pg.vue?vue&type=template&id=0762360c&scoped=true&"
import script from "./demo_pg.vue?vue&type=script&lang=js&"
export * from "./demo_pg.vue?vue&type=script&lang=js&"
import style0 from "./demo_pg.vue?vue&type=style&index=0&id=0762360c&prod&scoped=true&lang=css&"
import style1 from "./demo_pg.vue?vue&type=style&index=1&id=0762360c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0762360c",
  null
  
)

export default component.exports